import { render, staticRenderFns } from "./Regtopicgroups.vue?vue&type=template&id=7592177e&"
import script from "./Regtopicgroups.vue?vue&type=script&lang=js&"
export * from "./Regtopicgroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports